import RichTextAnchor from './RichTextAnchor';

export default RichTextAnchor;
